if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
          if (!event.detail.currentElement) return;

        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;
        this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) {
          deferredMedia.loadContent(false);
          const tryPlay = (attempts) => {
            const video = deferredMedia.querySelector('video');
            if (video) {
              video.muted = true;
              video.play().catch(() => {});
            } else if (attempts > 0) {
              setTimeout(() => tryPlay(attempts - 1), 200);
            }
          };
          setTimeout(() => tryPlay(10), 300);
        }
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

// Frecce miniature
document.addEventListener('DOMContentLoaded', () => {
  const thumbnails = document.querySelector('[id^="GalleryThumbnails"]');
  if (!thumbnails) return;

  const slider = thumbnails.querySelector('.slider');
  if (!slider) return;

  const wrapper = document.createElement('div');
  wrapper.className = 'thumbnail-slider-wrapper';
  thumbnails.parentNode.insertBefore(wrapper, thumbnails);
  wrapper.appendChild(thumbnails);

  const prev = document.createElement('button');
  prev.className = 'thumbnail-arrow thumbnail-arrow--prev';
  prev.innerHTML = '&#8249;';
  prev.style.fontSize = '2rem';
  prev.addEventListener('click', () => {
    slider.scrollBy({ left: -slider.offsetWidth / 2, behavior: 'smooth' });
  });

  const next = document.createElement('button');
  next.className = 'thumbnail-arrow thumbnail-arrow--next';
  next.innerHTML = '&#8250;';
  next.style.fontSize = '2rem';
  next.addEventListener('click', () => {
    slider.scrollBy({ left: slider.offsetWidth / 2, behavior: 'smooth' });
  });

  wrapper.appendChild(prev);
  wrapper.appendChild(next);
});
// Autoplay tutti i video al caricamento
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {

    // 1. Video nella galleria prodotto (miniature)
    const allThumbs = document.querySelectorAll('[id^="GalleryThumbnails"] [data-target]');
    allThumbs.forEach((thumb) => {
      const target = thumb.dataset.target;
      const mediaItem = document.querySelector(`[data-media-id="${target}"]`);
      if (mediaItem && mediaItem.querySelector('.deferred-media')) {
        thumb.querySelector('button')?.click();
      }
    });

    // 2. Tutti gli altri deferred-media nella pagina (sezione video separata)
    document.querySelectorAll('deferred-media').forEach((el) => {
      if (!el.getAttribute('loaded')) {
        el.loadContent(false);
        const tryPlay = (attempts) => {
          const video = el.querySelector('video');
          if (video) {
            video.muted = true;
            video.play().catch(() => {});
          } else if (attempts > 0) {
            setTimeout(() => tryPlay(attempts - 1), 200);
          }
        };
        setTimeout(() => tryPlay(10), 300);
      }
    });

  }, 800);
});

document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('media-gallery');
  if (!gallery) return;

  const firstVideoItem = gallery.querySelector('[data-media-type="video"], [data-media-type="external_video"]');
  if (!firstVideoItem) return;

  const mediaId = firstVideoItem.dataset.mediaId;
  if (!mediaId) return;

  setTimeout(() => {
    if (gallery && gallery.setActiveMedia) {
      gallery.setActiveMedia(mediaId, false);
    }
  }, 500);
});
